import React from 'react'
import { usePostRequest } from '../../../hooks/request'
import { USERS_LIST } from '../../../urls'
import { useMessage } from '../../../hooks/message'
import UsersForm from './UsersForm'

export default function UsersCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: USERS_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data: { ...data, chatId: data.chatId || undefined } })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>

            <UsersForm loading={brandCreate.loading} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
